import { KanbanBoard } from "./kanban";
import { KanbanColumn } from "./parts/column";
import { KanbanCard } from "./parts/view-card";

export type * from "./types-kanban";
export { KANBAN_EMPTY_MESSAGE, KANBAN_LOAD_MORE_LABEL, KANBAN_PAGE_SIZE } from "./kanban.constants";

/**
 * Módulo de cards (Figma `cards-kanban` 713:28466, `column` 713:29513 e `obras-cards-mostrar-mais` 12809:186387), casca:
 * `Kanban.Board` (colunas com rolagem horizontal), `Kanban.Column` (etapa, contador, vazio e "Mostrar mais") e
 * `Kanban.Card` (moldura; o corpo vem por `children`). Sem arrastar entre colunas.
 */
export const Kanban = { Board: KanbanBoard, Column: KanbanColumn, Card: KanbanCard };
